// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import BannerCropperController from "./banner_cropper_controller"
application.register("banner-cropper", BannerCropperController)

import BibleReaderController from "./bible_reader_controller"
application.register("bible-reader", BibleReaderController)

import BibleNoteEditorController from "./bible_note_editor_controller"
application.register("bible-note-editor", BibleNoteEditorController)

import BroadcastDedupController from "./broadcast_dedup_controller"
application.register("broadcast-dedup", BroadcastDedupController)

import CalendarSwipeController from "./calendar_swipe_controller"
application.register("calendar-swipe", CalendarSwipeController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ColorPaletteController from "./color_palette_controller"
application.register("color-palette", ColorPaletteController)

import DailyRhythmBiblePickerController from "./daily_rhythm_bible_picker_controller"
application.register("daily-rhythm-bible-picker", DailyRhythmBiblePickerController)

import DeclarativeWebPushDebugController from "./declarative_web_push_debug_controller"
application.register("declarative-web-push-debug", DeclarativeWebPushDebugController)

import ExamenController from "./examen_controller"
application.register("examen", ExamenController)

import FirebaseDebugController from "./firebase_debug_controller"
application.register("firebase-debug", FirebaseDebugController)

import TimedPracticeController from "./timed_practice_controller"
application.register("timed-practice", TimedPracticeController)

import TimedPracticeOpenerController from "./timed_practice_opener_controller"
application.register("timed-practice-opener", TimedPracticeOpenerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import JournalEditorController from "./journal_editor_controller"
application.register("journal-editor", JournalEditorController)

import InteractPaneController from "./interact_pane_controller"
application.register("interact-pane", InteractPaneController)

import MapPickerController from "./map_picker_controller"
application.register("map-picker", MapPickerController)

import MetricsController from "./metrics_controller"
application.register("metrics", MetricsController)

import MilestoneHintsController from "./milestone_hints_controller"
application.register("milestone-hints", MilestoneHintsController)

import NatureMapController from "./nature_map_controller"
application.register("nature-map", NatureMapController)

import PrayerWalkController from "./prayer_walk_controller"
application.register("prayer-walk", PrayerWalkController)

import PrayerWalkDataController from "./prayer_walk_data_controller"
application.register("prayer-walk-data", PrayerWalkDataController)

import PrayerWalkStartController from "./prayer_walk_start_controller"
application.register("prayer-walk-start", PrayerWalkStartController)

import PrayerWalkMapController from "./prayer_walk_map_controller"
application.register("prayer-walk-map", PrayerWalkMapController)

import PrayerPointsMapController from "./prayer_points_map_controller"
application.register("prayer-points-map", PrayerPointsMapController)

import NotificationCleanseController from "./notification_cleanse_controller"
application.register("notification-cleanse", NotificationCleanseController)

import NotificationPermissionController from "./notification_permission_controller"
application.register("notification-permission", NotificationPermissionController)

import NotificationPreferencesController from "./notification_preferences_controller"
application.register("notification-preferences", NotificationPreferencesController)

import PrayerSessionTimerController from "./prayer_session_timer_controller"
application.register("prayer-session-timer", PrayerSessionTimerController)

import PracticesStatsCloudController from "./practices_stats_cloud_controller"
application.register("practices-stats-cloud", PracticesStatsCloudController)

import ProfilePictureCropperController from "./profile_picture_cropper_controller"
application.register("profile-picture-cropper", ProfilePictureCropperController)

import PwaAwareController from "./pwa_aware_controller"
application.register("pwa-aware", PwaAwareController)

import PilgramageStepFormController from "./pilgramage_step_form_controller"
application.register("pilgramage-step-form", PilgramageStepFormController)

import PwaInstallationInstructionsController from "./pwa_installation_instructions_controller"
application.register("pwa-installation-instructions", PwaInstallationInstructionsController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import ScriptureDigController from "./scripture_dig_controller"
application.register("scripture-dig", ScriptureDigController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import SpiritualEventController from "./spiritual_event_controller"
application.register("spiritual-event", SpiritualEventController)

import SpiritualPracticeMetricsController from "./spiritual_practice_metrics_controller"
application.register("spiritual-practice-metrics", SpiritualPracticeMetricsController)

import SortController from "./sort_controller"
application.register("sort", SortController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import TechTreeController from "./tech_tree_controller"
application.register("tech-tree", TechTreeController)

import TimeTrackerController from "./time_tracker_controller"
application.register("time-tracker", TimeTrackerController)

import ToolPlacementDetailController from "./tool_placement_detail_controller"
application.register("tool-placement-detail", ToolPlacementDetailController)

import UserActionsLogsFilterController from "./user_actions_logs_filter_controller"
application.register("user-actions-logs-filter", UserActionsLogsFilterController)

import WaitingOnTheLordTimerController from "./waiting_on_the_lord_timer_controller"
application.register("waiting-on-the-lord-timer", WaitingOnTheLordTimerController)
